import { useEffect, useRef, useState } from "react";
import { logoQuy } from "../data/fundLogos.js";

// Ô chữ cái đầu khi quỹ chưa có logo hoặc file logo không tải được. Màu cố định
// theo fundId để bản prerender và bản chạy trên trình duyệt giống nhau.
const MAU_O_CHU = ["#16324f", "#2f6b4f", "#8a4a12", "#4e3f7a", "#7a2f3d", "#2c5a8a"];
export function oChu(f) {
  const tu = String(f.name || "").replace(/[()]/g, " ").split(/\s+/).filter((w) => /[\p{L}\d]/u.test(w));
  const chu = ((tu[0]?.[0] || "") + (tu[1]?.[0] || "")).toUpperCase() || "?";
  let h = 0;
  for (const c of String(f.fundId || f.name)) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return { chu, mau: MAU_O_CHU[h % MAU_O_CHU.length] };
}

/** Logo quỹ, hoặc ô chữ cái đầu. Trang trí thuần: tên quỹ luôn có chữ ở cạnh. */
export default function LogoQuy({ f, className = "nvq-o" }) {
  const src = logoQuy(f.slug);
  const [hong, setHong] = useState(false);
  const anh = useRef(null);
  useEffect(() => {
    // Ảnh lỗi trước khi React gắn sự kiện (HTML prerender) thì onError không chạy.
    const i = anh.current;
    if (i && i.complete && i.naturalWidth === 0) setHong(true);
  }, []);
  if (src && !hong) {
    return (
      <span className={className + " co-logo"} aria-hidden="true">
        <img ref={anh} src={src} alt="" loading="lazy" decoding="async" onError={() => setHong(true)} />
      </span>
    );
  }
  const o = oChu(f);
  return <span className={className} style={{ background: o.mau }} aria-hidden="true">{o.chu}</span>;
}
